import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import { FullRequestVehiclesHistory, ResumeVehicle } from 'src/types'
import api from 'src/services/api'
import objectToQueryString from 'src/helpers/object-to-query-string'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'

import * as Actions from './actions'

const axiosConfig = {
  timeout: 72000 // 1m20min
}

export function* getVehicles({
  payload: { customer_supplier_id, filters }
}: ReturnType<typeof Actions.getVehicles>) {
  try {
    const { user } = yield select((state: ApplicationState) => state.me)

    const queryString = objectToQueryString({
      checkin_date: filters.checkin_date,
      checkout_date: filters.checkout_date,
      customer_supplier_id,
      num_adults: filters.num_adults,
      resume: 'True',
      trend_destination_id: filters.trend_destination_id,
      trend_origin_id: filters.trend_origin_id,
      vehicles: filters.vehicles
    })

    const response: ApiResponse<{
      resume_vehicle: ResumeVehicle[]
      message_id: string[]
    }> = yield call(
      api.get,
      `organizations/${user.organization_id}/vehicles${queryString}`,
      null,
      axiosConfig
    )

    if (response.ok) {
      // @ts-ignore
      if (response.data.args) {
        yield put(Actions.getVehiclesSuccess([], []))
        return
      }

      yield put(
        Actions.getVehiclesSuccess(
          response.data.resume_vehicle,
          response.data.message_id
        )
      )
      return
    }

    if (response.status === 404) {
      yield put(Actions.getVehiclesSuccess([], []))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getVehiclesFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getVehicles', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getVehiclesFailure(message))
  }
}

export function* getVehiclesHistory({
  payload: { request_id }
}: ReturnType<typeof Actions.getVehiclesHistory>) {
  try {
    const { user } = yield select((state: ApplicationState) => state.me)

    const { data, ok }: ApiResponse<FullRequestVehiclesHistory> = yield call(
      api.get,
      `organizations/${user.organization_id}/requests/${request_id}/vehicle_historic`
    )
    if (ok) {
      // const fullHistory = data.full_request_vehicle[0]
      yield put(
        Actions.getVehiclesHistorySuccess({
          originalFullRequestVehiclesHistory: data
        })
      )
      return
    }
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getVehiclesHistoryFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getVehiclesHistory', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getVehiclesHistoryFailure(message))
  }
}
